import React, { useState } from 'react';
import colors from '../../colors';
import OutlineButton from './Buttons/outline/OutlinedModalButton';
import ModalContainer from './ModalContainer';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import Label from '../Label';
import MultilineInput from '../MultilineInput';
import MultiSearchSelect from '../MultiSearchSelect';
import ConfirmationModal from './ConfirmationModal';

function EditSpotCheckModal({ isVisible, setIsVisible, time, setTime, compliant, setCompliant, description, setDescription, measures, setMeasures, allMeasures, add, saveCallback, deleteCallback, isEditable }) {

  const modalContainerStyles = {
    padding: '10px 20px 25px',
  }

  const timeContainerStyles = {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  };

  const compliantStyles = {
    width: '100%',
    textAlign: 'left',
  };

  const radioGroupStyles = {
    display: 'flex',
    gap: '20px',
  }

  const radioLabelStyles = {
    display: 'flex',
    alignItems: 'center'
  }
  const radioStyles = {
    width: '1.5rem',
    height: '1.1rem',
  }
  const measuresContainerStyles = {
    width: '100%',
    textAlign: 'left'
  }
  const btnGroupStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px'
  }

  const errMsgStyles = {
    color: 'red',
    marginTop: '-12px'
  }

  const [errMsg, setErrMsg] = useState();
  const [deleteModalIsVisible, setDeleteModalIsVisible] = useState(false);

  const handleSave = () => {
    if (time === undefined || compliant === undefined) {
      setErrMsg('Please fill out all required fields');
      return;
    }
    setIsVisible(false);
    saveCallback();
  };

  const handleClose = () => {
    setIsVisible(false);
    setErrMsg()
  };

  const handleNow = () => setTime(new Date());

  const handleDelete = () => {
    setIsVisible(false);
    setErrMsg();
    deleteCallback();
  }

  return (
    <ModalContainer isVisible={isVisible} setIsVisible={setIsVisible} title={add ? "Add Spot Check" : "Edit Spot Check"} style={modalContainerStyles} onClose={handleClose}>
      <div style={timeContainerStyles}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            label={"Time"}
            value={time && dayjs(time)}
            onChange={(newValue) => newValue && setTime(newValue.toDate())}
            sx={{ width: '130px' }}
            disabled={!isEditable}
          />
        </LocalizationProvider>
        <OutlineButton color={colors.blue} label={'Now'} style={{ borderRadius: '8px', width: '120px' }} onClick={handleNow} disabled={!isEditable}/>
      </div>
      <div style={compliantStyles}>
        <Label>Compliant</Label>
        <div style={radioGroupStyles}>
          <div style={radioLabelStyles}>
            <input type='radio' id='yesBtn' value='yes' name='compliant' style={radioStyles} defaultChecked={compliant === true} onClick={() => setCompliant(true)} disabled={!isEditable} />
            <label htmlFor='yesBtn'>Yes</label>
          </div>
          <div style={radioLabelStyles}>
            <input type='radio' id='noBtn' value='no' name='compliant' style={radioStyles} defaultChecked={compliant === false} onClick={() => setCompliant(false)} disabled={!isEditable}/>
            <label htmlFor='noBtn'>No</label>
          </div>
        </div>
      </div>

      {compliant === false &&
        <div style={measuresContainerStyles}>
          <Label>Neglected Control Measures (optional)</Label>
          <MultiSearchSelect options={allMeasures} selected={measures} setSelected={setMeasures} disabled={!isEditable}/>
        </div>
      }

      <MultilineInput label='Description (optional)' setText={setDescription} placeholder={'Enter description'} value={description} disabled={!isEditable}/>

      {errMsg && <span style={errMsgStyles}>{errMsg}</span>}

      {isEditable &&
        <div style={btnGroupStyles}>
          {add ? <OutlineButton
            color={colors.gray}
            label={'Cancel'}
            onClick={handleClose} />
            :
            <OutlineButton
              color={colors.red}
              label={'Delete'}
              onClick={() => setDeleteModalIsVisible(true)} />
          }

          <OutlineButton
            color={colors.green}
            label={add ? 'Create' : 'Save'}
            onClick={handleSave} />

        </div>
      }
      <ConfirmationModal isVisible={deleteModalIsVisible} setIsVisible={setDeleteModalIsVisible} mainAction={'Delete'} mainActionHandler={handleDelete} title={'Are you sure you want to delete this Spot Check?'} />
    </ModalContainer>
  );
}

export default EditSpotCheckModal;
